import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { backUrl } from '../config';

const redPath = 'paymentCodeApi'; // change
const tagApi = 'payment-codes'; // change

export const paymentCodeApi = createApi({
  // change
  reducerPath: redPath,
  baseQuery: fetchBaseQuery({
    baseUrl: backUrl,
    tagTypes: [tagApi],
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.accessToken;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    getPaymentCode: build.query({
      // change
      query: (param) => `${tagApi}${param ? param : ''}`,
      providesTags: [tagApi],
    }),
    createPaymentCode: build.mutation({
      // change
      query: (newData) => ({
        url: `${tagApi}`,
        method: 'POST',
        body: {
          data: {
            ...newData,
          },
        },
      }),
      invalidatesTags: [tagApi],
    }),
    updatePaymentCode: build.mutation({
      // change
      query: (newData) => ({
        url: `${tagApi}/${newData.id}`,
        method: 'PUT',
        body: {
          data: {
            ...newData.updated,
          },
        },
      }),
      invalidatesTags: [tagApi],
    }),
  }),
});

export const {
  useGetPaymentCodeQuery,
  useCreatePaymentCodeMutation,
  useUpdatePaymentCodeMutation,
} = paymentCodeApi; // change
